import { apiFetch } from './api';
import type { AppRole } from '@4m/shared/enums';

export interface MeProfile {
  id: string;
  user_id: string;
  agent_id: string;
  full_name: string;
  title: string | null;
  email: string | null;
  phone: string | null;
  avatar_key: string | null;
  avatar_url: string | null;
  background_url: string | null;
  ui_preferences: string;
  role: AppRole;
  status: 'active' | 'inactive';
  cc_default_makler_id: string | null;
  /** Batch AB — admin-toggled access to /zinshaeuser page. Admin role
   *  always passes regardless of this flag. */
  zinshaus_access: boolean;
  /** Seller rules (0055) — sees real seller phone numbers (admin1 always). */
  phone_access: boolean;
  /** Seller rules (0055) — compliance manager (admin role + flag). */
  seller_compliance: boolean;
  updated_at: number | null;
}

export interface MeUser {
  id: string;
  email: string;
}

export interface MeResponse {
  user: MeUser;
  profile: MeProfile;
}

export async function fetchMe(): Promise<MeResponse | null> {
  const res = await apiFetch('/auth/me');
  if (res.status === 401 || res.status === 403) return null;
  if (!res.ok) throw new Error(`fetch_me_failed_${res.status}`);
  return (await res.json()) as MeResponse;
}

export async function loginAsAgent(agentId: string, password?: string) {
  const res = await apiFetch('/auth/agent', {
    method: 'POST',
    body: JSON.stringify({ agentId, ...(password ? { password } : {}) }),
  });
  if (!res.ok) {
    const data = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(data?.error ?? `login_failed_${res.status}`);
  }
}

export async function logout() {
  await apiFetch('/auth/logout', { method: 'POST' });
}
